var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextList',{attrs:{"value":_vm.listValue,"type":_vm.type,"min":_vm.minItems,"max":_vm.maxItems},on:{"input":function($event){return _vm.emitAnswer($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }